import { render, staticRenderFns } from "./gbkCompanyBusiness.vue?vue&type=template&id=46764be1&scoped=true&"
import script from "./gbkCompanyBusiness.vue?vue&type=script&lang=js&"
export * from "./gbkCompanyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./gbkCompanyBusiness.vue?vue&type=style&index=0&id=46764be1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46764be1",
  null
  
)

export default component.exports